import { useEffect, useState } from "react";
import { getNews, createNews, updateNews, deleteNews } from "../../../services/news";

export default function useNews() {
  const [isLoading, setIsLoading] = useState(true);
  const [news, setNews] = useState([]);

  const saveNew = async (newSetting, newsId) => {
    let res;
    if (newsId) {
      res = await updateNews(newsId, newSetting);
      if (res) {
        setNews((prevNews) =>
          prevNews.map((n) => (n.id === newsId ? res : n))
        );
      }
    } else {
      res = await createNews(newSetting);
      if (res) {
        setNews((prevNews) => [...prevNews, res]);
      }
    }
    return res;
  };

  const deleteNew = async (newsId) => {
    const res = await deleteNews(newsId);
    if (res) {
      setNews((prevNews) =>
        prevNews.map((n) => (n.id === newsId ? { ...n, status: "deleted" } : n))
      );
    }
    return res;
  };

  const fetchData = async () => {
    const data = await getNews();
    if (data) {
      setNews(data);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return {
    isLoading,
    news,
    saveNew,
    deleteNew,
  };
}